var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "unitDetails" } },
    [
      _c(
        "div",
        { ref: "scrollArea", staticClass: "section-content" },
        [
          _vm.selected
            ? [
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "vo-header" }, [
                    _vm._v("\n          Invite Details\n        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vo-content" }, [
                    _c("div", { staticClass: "details" }, [
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Email Address")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.selected.email))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Invited Date")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateShorthand")(_vm.selected.created)
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [_vm._v("Role")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value vo-site-link" }, [
                          _vm._v(_vm._s(_vm.selected.role.parent.title))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Access Level")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value vo-site-link" }, [
                          !_vm.selected.role.unit && !_vm.selected.role.property
                            ? _c("div", [_vm._v("All Properties")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.property
                            ? _c("div", [_vm._v(_vm._s(_vm.property.name))])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.unit
                            ? _c("div", [_vm._v(_vm._s(_vm.unit.title))])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clear" })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vo-footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "vo-button",
                          attrs: { flat: "" },
                          on: { click: _vm.resendInviteDialog }
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-send")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Resend")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "vo-button red",
                          attrs: { flat: "" },
                          on: { click: _vm.deleteInviteDialog }
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-cancel")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Cancel")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            : [_c("vo-empty-state", { attrs: { text: "SELECT AN INVITE" } })]
        ],
        2
      ),
      _vm._v(" "),
      _c("vo-details-header")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f12230e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f12230e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InviteDetails.vue
// module id = 503
// module chunks = 4